"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsClient = void 0;
var base_client_1 = require("./base-client");
/**
 * Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
API and offers examples of usage.

The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
 * @class ReportsClient
 * @param {(string)} [url] - The URL of the API endpoint.
 */
var ReportsClient = /** @class */ (function (_super) {
    __extends(ReportsClient, _super);
    function ReportsClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
    * Retrieve a list of base reports for a specified owner, client or user.
    * @method
    * @name ReportsClient#listAnalyticsBaseReports
         * @param {string} owner - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} client - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} user - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {number} offset - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {number} limit - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.listAnalyticsBaseReports = function (owner, client, user, offset, limit, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/analytics';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (client !== undefined) {
                            queryParameters['client'] = client;
                        }
                        if (user !== undefined) {
                            queryParameters['user'] = user;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve an analytics base report by its ID.
     * @method
     * @name ReportsClient#getAnalyticsBaseReport
     * @param {string} id - The UUID to retrieve.
     */
    ReportsClient.prototype.getAnalyticsBaseReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/analytics/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Rebuilds a base report
    * @method
    * @name ReportsClient#rebuildAnalyticsBaseReport
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.rebuildAnalyticsBaseReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/analytics/{id}/rebuild';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Rebuilds a base report
    * @method
    * @name ReportsClient#getAnalyticsBaseReportLogs
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} levels - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {number} limit - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.getAnalyticsBaseReportLogs = function (id, levels, limit, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/analytics/{id}/logs';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if (levels !== undefined) {
                            queryParameters['levels'] = levels;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Retrieve a list of queued reports for a specified owner.
    * @method
    * @name ReportsClient#listCompletedReports
         * @param {string} start - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} end - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} client - The client id you are requesting reports for
         * @param {string} user - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.listCompletedReports = function (start, end, client, user, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/history';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (start !== undefined) {
                            queryParameters['start'] = start;
                        }
                        if (start === undefined || start === null) {
                            throw new Error('Missing required string parameter: start');
                        }
                        if (end !== undefined) {
                            queryParameters['end'] = end;
                        }
                        if (end === undefined || end === null) {
                            throw new Error('Missing required string parameter: end');
                        }
                        if (client !== undefined) {
                            queryParameters['client'] = client;
                        }
                        if (user !== undefined) {
                            queryParameters['user'] = user;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a queued report by it's ID.
     * @method
     * @name ReportsClient#getCompletedReport
     * @param {string} id - The UUID to retrieve.
     */
    ReportsClient.prototype.getCompletedReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/history/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Update a report by it's ID.
     * @method
     * @name ReportsClient#updateCompletedReport
     * @param {string} id - The UUID of the report to update
     * @param {object} report - The data with which to update an existing report.
     */
    ReportsClient.prototype.updateCompletedReport = function (id, report, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/history/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (report === undefined || report === null) {
                    throw new Error('Missing required object parameter: report');
                }
                if (report !== undefined) {
                    body = report;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Retrieve a queued report by it's ID.
    * @method
    * @name ReportsClient#getCompletedReportWithOptions
         * @param {string} id - The UUID to retrieve.
         * @param {object} options - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.getCompletedReportWithOptions = function (id, options, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/history/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (options === undefined || options === null) {
                    throw new Error('Missing required object parameter: options');
                }
                if (options !== undefined) {
                    body = options;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve the binary data for a queued report by it's ID.
     * @method
     * @name ReportsClient#getCompletedReportData
     * @param {string} id - The UUID to retrieve.
     * @param {string} filename - The filename and type your want the to be returned as, can be '.pdf', '.csv' or '.json'
     */
    ReportsClient.prototype.getCompletedReportData = function (id, filename, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/history/{id}/{filename}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if (filename === undefined || filename === null) {
                            throw new Error('Missing required string parameter: filename');
                        }
                        path = path.replace('{filename}', filename.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Retrieve the binary data for a queued report by it's ID.
    * @method
    * @name ReportsClient#getCompletedReportDataWithOptions
         * @param {string} id - The UUID to retrieve.
         * @param {string} filename - The filename and type your want the data to be returned as, can be '.pdf', '.csv' or '.json'
         * @param {object} options - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.getCompletedReportDataWithOptions = function (id, filename, options, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/history/{id}/{filename}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (filename === undefined || filename === null) {
                    throw new Error('Missing required string parameter: filename');
                }
                path = path.replace('{filename}', filename.toString());
                if (options === undefined || options === null) {
                    throw new Error('Missing required object parameter: options');
                }
                if (options !== undefined) {
                    body = options;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Retrieve the binary data for a queued report by it's ID.
    * @method
    * @name ReportsClient#getCompletedReportDataStream
         * @param {string} id - The UUID to retrieve.
         * @param {string} filename - The filename and type your want the to be returned as, can be '.pdf', '.csv' or '.json'
         * @param {string} outputFormat - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.getCompletedReportDataStream = function (id, filename, outputFormat, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/history/{id}/stream/{filename}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if (filename === undefined || filename === null) {
                            throw new Error('Missing required string parameter: filename');
                        }
                        path = path.replace('{filename}', filename.toString());
                        if (outputFormat !== undefined) {
                            queryParameters['outputFormat'] = outputFormat;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Retrieve a list of queued reports for a specified owner.
    * @method
    * @name ReportsClient#listQueuedReports
         * @param {string} client - The client id you are requesting reports for
         * @param {string} user - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} server - An optional server identifier (will be inferred from client settings if possible)
    */
    ReportsClient.prototype.listQueuedReports = function (client, user, server, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/queues';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (client !== undefined) {
                            queryParameters['client'] = client;
                        }
                        if (user !== undefined) {
                            queryParameters['user'] = user;
                        }
                        if (server !== undefined) {
                            queryParameters['server'] = server;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Queue a new report
    * @method
    * @name ReportsClient#queueReport
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.queueReport = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/queues';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a queued report by it's ID.
     * @method
     * @name ReportsClient#getQueuedReport
     * @param {string} id - The UUID to retrieve.
     */
    ReportsClient.prototype.getQueuedReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/reports/queues/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Cancel a queued or running report
    * @method
    * @name ReportsClient#cancelReport
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    ReportsClient.prototype.cancelReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/reports/queues/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    return ReportsClient;
}(base_client_1.BaseClient));
exports.ReportsClient = ReportsClient;
